import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";

// Screens that don't require authentication
import LandingScreen from "./screens/LandingScreen";
import ContactScreen from "./screens/ContactScreen";
import LoginScreen from "./screens/LoginScreen";
import RegisterScreen from "./screens/RegisterScreen";

// Screens that do require authentication
import HomeScreen from "./screens/HomeScreen";
import PostList from "./components/posts/PostList";
import PostForm from "./components/posts/PostForm";
import DevelopmentScreen from "./screens/DevelopmentScreen";
import AdminDashboardScreen from "./screens/AdminDashboardScreen";
import AddDeveloperScreen from "./screens/AddDeveloperScreen";
import AddProjectScreen from "./screens/AddProjectScreen";
import EditDeveloperScreen from "./screens/EditDeveloperScreen";
import EditProjectScreen from "./screens/EditProjectScreen";
import AddPostScreen from "./screens/AddPostScreen";
import EditPostScreen from "./screens/EditPostScreen";
import PrivateRoute from "./components/PrivateRoute";
import ForgotPasswordScreen from "./screens/ForgotPasswordScreen";
import ChangePasswordScreen from "./screens/ChangePasswordScreen";
import ResetPasswordScreen from "./screens/ResetPasswordScreen";

const App = () => {
  return (
    <Router>
      <Header />
      <main>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<LandingScreen />} />
          <Route path="/contact" element={<ContactScreen />} />
          {/* <Route path="/login" element={<LoginScreen />} /> */}
          <Route path="/register" element={<RegisterScreen />} />
          <Route path="/forgot-password" element={<ForgotPasswordScreen />} />
          <Route path="/reset-password" element={<ResetPasswordScreen />} />
          {/* Private Routes */}
          <Route
            path="/home"
            element={<PrivateRoute element={<HomeScreen />} />}
          />
          <Route
            path="/change-password"
            element={<PrivateRoute element={<ChangePasswordScreen />} />}
          />
          <Route
            path="/posts"
            element={<PrivateRoute element={<PostList />} />}
          />
          <Route
            path="/posts/new"
            element={<PrivateRoute element={<PostForm />} />}
          />
          <Route
            path="/posts/:id"
            element={<PrivateRoute element={<DevelopmentScreen />} />}
          />
          <Route path="/posts/:id" element={<DevelopmentScreen />} />
          {/* Admin Dashboard */}
          <Route
            path="/admin-dashboard"
            element={
              <PrivateRoute
                element={<AdminDashboardScreen />}
                adminOnly={true} // Ensure only admins can access
              />
            }
          />
          /
          <Route
            path="/add-developer"
            element={
              <PrivateRoute element={<AddDeveloperScreen />} adminOnly={true} />
            }
          />
          <Route
            path="/add-project/:developerId/:developerName"
            element={
              <PrivateRoute element={<AddProjectScreen />} adminOnly={true} />
            }
          />
          <Route
            path="/edit-developer/:developerId"
            element={
              <PrivateRoute element={<EditDeveloperScreen />} adminOnly />
            }
          />
          <Route
            path="/edit-project/:projectId"
            element={<PrivateRoute element={<EditProjectScreen />} adminOnly />}
          />
          <Route
            path="/create-post/:projectId"
            element={<PrivateRoute element={<AddPostScreen />} adminOnly />}
          />
          <Route
            path="/edit-post/:postId"
            element={
              <PrivateRoute element={<EditPostScreen />} adminOnly={true} />
            }
          />
          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </main>
      <Footer />
    </Router>
  );
};

export default App;
